import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, Search } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-md"
      >
        {/* 404 Visual */}
        <div className="relative mb-8">
          <div className="text-[120px] font-black text-gray-100 leading-none select-none">404</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-[#7FA86A] to-[#96BE82] flex items-center justify-center shadow-xl shadow-[rgba(127,168,106,0.2)]">
              <Search className="w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>

        <h1 className="text-[28px] font-bold text-gray-900 mb-3 tracking-tight">Page Not Found</h1>
        <p className="text-[15px] text-gray-500 leading-relaxed mb-8">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 h-12 px-6 bg-[#1D1D1F] text-white rounded-2xl font-semibold text-[15px] hover:bg-black transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            <Home className="w-4 h-4" aria-hidden="true" />
            Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 h-12 px-6 border-2 border-gray-200 text-gray-700 rounded-2xl font-semibold text-[15px] hover:border-gray-400 transition-all active:scale-[0.98]"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden="true" />
            Go Back
          </button>
        </div>

        {/* Quick Links */}
        <div className="mt-10 pt-8 border-t border-gray-100">
          <p className="text-[13px] text-gray-400 mb-4">Popular pages</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {[
              { label: 'Home', href: '/' },
              { label: 'Services', href: '/services' },
              { label: 'Products', href: '/products' },
              { label: 'Contact', href: '/contact' },
              { label: 'Warranty', href: '/warranty' },
            ].map(link => (
              <Link
                key={link.href}
                to={link.href}
                className="px-4 py-1.5 rounded-full bg-gray-100 text-gray-600 text-[13px] font-medium hover:bg-gray-200 transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
}
